import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';

// Experiences are shared from an item: Browse -> item -> dedicated Share
// Experience page. With an item in context this opens that page (the action
// is chosen there); otherwise it starts at Browse.
export const ShareExperienceButton = ({ item: itemProp, fullWidth = false, sx = {} }) => {

    const navigate = useNavigate();
    const { item: contextItem } = useSelector(state => state.itemContext);
    const item = itemProp || contextItem;

    const handleClick = () => {
        if (item?.id) {
            navigate(`/share-experience/${item.id}`);
        } else {
            navigate('/browse');
        }
    }

    return (
        <Button
            variant="contained"
            onClick={handleClick}
            fullWidth={fullWidth}
            startIcon={item?.id ? <AddIcon /> : <SearchIcon />}
            sx={{ borderRadius: '8px', minHeight: 44, px: 2.5, ...sx }}
        >
            {item?.id ? 'Share your experience' : 'Find something to share'}
        </Button>
    );
}
